var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.021,
    height: 31.021,
    viewBox: "0 0 31.021 31.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "landmark",
    d: "M30.392,5.581,16.192.124a1.936,1.936,0,0,0-1.361,0L.629,5.581A.969.969,0,0,0,0,6.488V8.725a.969.969,0,0,0,.969.969H30.052a.969.969,0,0,0,.969-.969V6.488A.969.969,0,0,0,30.392,5.581ZM3.878,11.633v9.694H2.908a.969.969,0,0,0-.969.969V25.2H29.082V22.3a.969.969,0,0,0-.969-.969h-.969V11.633H23.266v9.694H17.449V11.633H13.572v9.694H7.755V11.633ZM30.052,27.143H.969A.969.969,0,0,0,0,28.113v1.939a.969.969,0,0,0,.969.969H30.052a.969.969,0,0,0,.969-.969V28.113A.969.969,0,0,0,30.052,27.143Z",
    transform: "translate(0 0)",
    fill: "#51c0e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.795aaff85ceb605593e5c07abbfc92b8.svg";
export { ForwardRef as ReactComponent };